import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router, private authService: AuthService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    req = this.addWithCredentials(req);

    return next.handle(req).pipe(catchError(err => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            this.authService.logout(false); // Clears out localStorage and toggles the Login/Logout navigation link
            this.router.navigate(['/logout']); // Send user to page explaining that they have been logged out
          }
        }

         return throwError(err);

      }));

  }

  private addWithCredentials(request: HttpRequest<any>)
  {
    return request.clone({ withCredentials: true});
  }

}

export const authInterceptorProviders= [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
];